export const ERROR_PAGE_DESCRIPTION_KEY = 'description';
export const ERROR_PAGE_DEVELOPMENT_KEY = '500-error';
export const ERROR_PAGE_IMAGES_DEVELOPMENT_KEY = '500ImageAltText';
export const ERROR_PAGE_IMAGE_KEY = '500Image';
export const ERROR_PAGE_TITLE_KEY = 'title';
export const ERROR_PAGE_LIST_HEADING_KEY = 'listheading';
export const ERROR_PAGE_ANALYTICS_PAGE_NAME = 'Error Page | 500';
